import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { _UPDATE_USER_ROLE } from "../../../models/rbacModel";
import { formToObject } from "../../../utils";

const EditRoleFormComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_USER_ROLE(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Updated");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
      }
      setLoader(false);
    });
  };

  const field = (fieldName) => props.dataSource[fieldName] || "";

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="id" value={field("id")} />
          <Row>
            <Col md={3}>
              <PsLabel text="Role" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="role_name"
                placeholder="Role"
                defaultValue={field("role_name")}
                size="sm"
                className="fw-bold"
                autoFocus
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Order" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="number"
                name="display_order"
                defaultValue={field("display_order")}
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={3}>
              <PsLabel text="Status" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="active_status"
                size="sm"
                defaultValue={field("active_status")}
                className="fw-bold form-select form-select-sm"
                required
              >
                <option
                  value="1"
                  selected={field("active_status") == "1" ? "selected" : ""}
                >
                  Active
                </option>
                <option
                  value="0"
                  selected={field("active_status") == "0" ? "selected" : ""}
                >
                  In-Active
                </option>
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Update
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const EditRoleForm = (props) => {
  return (
    <>
      <PsModalWindow size="sm" title="Edit Role" {...props}>
        {props.show && <EditRoleFormComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default EditRoleForm;
